import StyleGuide from '@/style-guide/style-guide.view.vue';

const StyleGuideRouter = { // only develop
  path: '/style-guide',
  name: 'styleGuide',
  component: StyleGuide,
};

export default [
  StyleGuideRouter,
];
